import React from "react";
import { Shield, Clock, Trash2 } from "lucide-react";

export default function DeleteConfirmModal({ open, onCancel, onConfirm }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-[#FEFDFD] rounded-3xl  w-full max-w-md sm:max-w-lg p-6 sm:p-8">
        <div className="w-full mb-6">
          <img
            src="/img/dashboard/delete-blog-illustration.svg"
            alt="Delete blog post"
            className="w-full h-auto object-contain"
          />
        </div>


        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 border border-slate-200 text-slate-700 font-semibold text-sm py-3 rounded-full hover:bg-slate-50 active:scale-[0.98] transition-all duration-200"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 inline-flex items-center justify-center gap-2 bg-red-500 text-white font-semibold text-sm py-3 rounded-full hover:bg-red-600 active:scale-[0.98] transition-all duration-200"
          >
            Delete <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
